"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.uniqueid"));

var _nav = _interopRequireDefault(require("../Nav/nav"));

var _link = _interopRequireDefault(require("../Link/link"));

var _children = require("../helpers/children");

var _header = _interopRequireDefault(require("../Header/header"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateAnchorIds(names) {
  return names.map(function (name) {
    return name.trim().toLowerCase().replace(' ', '_') + (0, _lodash.default)('_');
  });
}

function getNormalizedSectionNames(childrenProp) {
  var sectionNames = [];

  _react.default.Children.forEach(childrenProp, function (section) {
    var header = (0, _children.getFirstDirectChildOfTypes)(section.props.children, [_header.default]);

    if (header) {
      var headerTitle = _header.default.getTitleText(header);

      if (headerTitle) {
        sectionNames.push(headerTitle);
      }
    }
  });

  return sectionNames;
}

var SectionGroup = function SectionGroup(_ref) {
  var children = _ref.children,
      _ref$withNavigation = _ref.withNavigation,
      withNavigation = _ref$withNavigation === void 0 ? true : _ref$withNavigation;
  var components;

  if (withNavigation) {
    var sectionNames = getNormalizedSectionNames(children);
    var ids = generateAnchorIds(sectionNames);
    components = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(SectionNavigation, {
      sectionNames: sectionNames,
      ids: ids
    }), _react.default.createElement(SectionList, {
      ids: ids
    }, children));
  } else {
    components = _react.default.createElement(SectionList, null, children);
  }

  return _react.default.createElement("section", {
    className: "co-section-group"
  }, components);
};

var SectionNavigation = function SectionNavigation(_ref2) {
  var _ref2$sectionNames = _ref2.sectionNames,
      sectionNames = _ref2$sectionNames === void 0 ? [] : _ref2$sectionNames,
      ids = _ref2.ids;
  return _react.default.createElement("aside", {
    className: "co-section-group__nav"
  }, _react.default.createElement(_nav.default, {
    vertical: true
  }, sectionNames.map(function (name, index) {
    return _react.default.createElement(_nav.default.Item, {
      key: name
    }, _react.default.createElement(_link.default, {
      href: '#' + ids[index]
    }, name));
  })));
};

var SectionList = function SectionList(_ref3) {
  var children = _ref3.children,
      ids = _ref3.ids;
  var index = 0;
  return _react.default.createElement("div", {
    className: "co-section-group__sections"
  }, _react.default.Children.map(children, function (child) {
    var withId = _react.default.cloneElement(child, ids ? {
      id: ids[index]
    } : null);

    index++;
    return withId;
  }));
};

SectionGroup.propTypes = {
  /** Must be of type Section */
  children: _propTypes.any.isRequired,
  withNavigation: _propTypes.bool
};
SectionNavigation.propTypes = {
  sectionNames: _propTypes.array.isRequired,
  ids: _propTypes.array.isRequired
};
SectionList.propTypes = {
  /** Must be of type Section */
  children: _propTypes.any.isRequired,
  ids: _propTypes.array
};
var _default = SectionGroup;
exports.default = _default;
SectionGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SectionGroup",
  "props": {
    "withNavigation": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "Must be of type Section"
    }
  }
};